module.exports = __webpack_public_path__ + "static/media/cow-img.cb0fae7a.png";